export const PROGRESS_BAR_MAP = [
  {
    title: 'PERSONAL INFO',
    icon: {
      url: '/assets/icons/progress-bar/personal-info.svg'
    },
    icon_mobile: {
      url: '/assets/icons/progress-bar/personal-info-mobile.svg'
    }
  },
  {
    title: 'PROJECT INFO',
    icon: {
      url: '/assets/icons/progress-bar/project-info.svg'
    },
    icon_mobile: {
      url: '/assets/icons/progress-bar/project-info-mobile.svg'
    }
  },
  {
    title: 'PICK DATE & TIME',
    icon: {
      url: '/assets/icons/progress-bar/pick-date-time.svg'
    },
    icon_mobile: {
      url: '/assets/icons/progress-bar/pick-date-time-mobile.svg'
    }
  },
  {
    title: 'CONFIRM DETAILS',
    icon: {
      url: '/assets/icons/progress-bar/confirm-details.svg'
    },
    icon_mobile: {
      url: '/assets/icons/progress-bar/confirm-details-mobile.svg'
    }
  },
];
